import React from "react";
import { connect } from "react-redux";

import { Configuration } from "../../configs/Configuration";
import TranslationDataFetcher from "../../dataFetchers/translationsDataFetcher";
import ConfigDataFetcher from "../../dataFetchers/configsDataFetcher";
import { fetchViewedRecos } from "../../dataFetchers/recoDataFetcher";
import { getBECompatibleLocale, prepareColorsData, replaceColorsInCss } from "../../helpers/helper";
import BCLLoading from '../common/Loading/BCLLoading';
import { setAndPrepareStateParam, getCleanURL } from "../../helpers/URLHelper";
import { setQueryParams} from  "../../actions/queryParamsAction";
import { fetchApplianceMapping } from '../../dataFetchers/appliancesDataFetcher';

export const withBaseContainer = (ChildComponent) => {
  class BaseContainer extends React.Component {
    configuration = Configuration.getConfiguration();

    componentDidMount() {
      const {location} = this.props;
      this.props.fetchConfigData({ pilotId: this.configuration.pilotId});
      this.props.fetchColorPaletteData({ pilotId: this.configuration.pilotId});
      this.props.fetchViewedRecos(this.props.userIdentityDetails.userId);
      let queryParamsObj = setAndPrepareStateParam(location, false);
      if (Object.keys(queryParamsObj).length > 0) {
        this.props.setQueryParams(queryParamsObj);
      }
      this.props.history.push(getCleanURL(location));
    }

    componentDidUpdate(prevProps) {
      if (!prevProps.configs.data && this.props.configs && this.props.configs.data) {
        let locale = getBECompatibleLocale(this.props.configs.data);
        this.props.fetchApplianceMapping(this.props.userIdentityDetails.userId, locale);
        this.props.fetchAllTranslations({ pilotId: this.configuration.pilotId, locale: locale});
      }

      if ((!prevProps.configs.data || !prevProps.configs.colorPallete) && this.props.configs.colorPallete) {
        if (this.props.configs && this.props.configs.colorPallete) {
          const COLORS_TO_REPLACE = prepareColorsData(this.props.configs.colorPallete);
          replaceColorsInCss(COLORS_TO_REPLACE);
        }
      }
    }

    render() {
      return (
        <>
          {
            this.props.configs && this.props.configs.colorPallete && this.props.configs.data && this.props.translationsData && this.props.translationsData.data ?
              <ChildComponent {...this.props}/>
            :
              <BCLLoading />
          }
        </>
      );
    }
  }

  const mapStateToProps = state => {
    return {
      userObject: state.userObject,
      userIdentityDetails: state.userIdentityDetails,
      configs: state.configs,
      translationsData: state.translationsData,
      recommendationsData: state.recommendationsData,
      queryParams: state.queryParams
    }
  };

  const mapDispatchToProps = dispatch => {
    return {
      fetchConfigData: options => dispatch(ConfigDataFetcher.fetchConfigData(options)),
      fetchAllTranslations: options => dispatch(TranslationDataFetcher.fetchAllTranslations(options)),
      fetchColorPaletteData: options => dispatch(ConfigDataFetcher.fetchColorPaletteData(options)),
      fetchViewedRecos: options => dispatch(fetchViewedRecos(options)),
      setQueryParams: queryParamsObj => dispatch(setQueryParams(queryParamsObj)),
      fetchApplianceMapping: (uuid, locale) => dispatch(fetchApplianceMapping(uuid, locale))
    };
  };

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(BaseContainer);
}
